import React from 'react';
import { View } from "react-native"
import { Icon } from "react-native-elements"
import { Text, TouchableOpacity } from "../../../globalComponents/NativeOverrides"
import Colors from "../../../constants/Colorsv2"

type MarketCardFooterProps = {
    open_order_count?:number;
    onMarketPress: () => void,
    onStatPress: () => void,
}

const MarketCardFooter = ({ open_order_count, onStatPress, onMarketPress }:MarketCardFooterProps) => {


    const handlePress = (action:string) => {
        if(action === 'stat'){
            if(!onStatPress){ return }
            return onStatPress()
        }
        if(action === 'market'){
            if(!onMarketPress){ return }
            return onMarketPress()
        }
    }


    return (
        <View style={{ flexDirection: 'row', justifyContent:'space-between', padding:5, borderTopWidth:1, borderColor:Colors.shades.shade100 }}>
            <TouchableOpacity onPress={() => handlePress('stat')}>
                <Text size={12} color={Colors.brand.electric} weight='regular' textAlign="left">{open_order_count??0} open orders</Text>
            </TouchableOpacity>
            <TouchableOpacity style={{ flexDirection:'row', alignItems:'center' }} onPress={() => handlePress('market')}>
                <Text style={{marginRight:5}} size={12} color={Colors.brand.electric} weight='regular' textAlign="right">Market Details</Text>
                <Icon name='chevron-right' color={Colors.brand.electric} type='feather' size={12} />
            </TouchableOpacity>
        </View>
    )
}

export default MarketCardFooter